export default __webpack_public_path__ + "static/media/1015.e45d3e17.svg";